import type { RouteLocationRaw } from 'vue-router'
import type { PropType } from '@/composition/vue/compositionApi'
import type { IconName } from '@/assets/icons/icons'
import type { StatusColor } from '@/components/shared/types'

export type TmBadgeColors =
  | 'blue'
  | 'green'
  | 'orange'
  | 'red'
  | 'mint'
  | 'purple'
  | 'crimson'
  | 'brown'
  | 'gray'
  | 'primary'
  | 'success'
  | 'warning'
  | 'error'
  | 'cyan'
  | 'violet'
  | 'purpur'

export type TmGradientBadgeTheme = 'purple' | 'purpleBlue' | 'green'

export type BadgeAppearance = 'pastel' | 'intense'

export type BadgeVariant = 'static' | 'button' | 'link'

export const TmBadgeProps = {
  frozen: {
    type: Boolean,
  },
  disabled: {
    type: Boolean,
  },
  closable: {
    type: Boolean,
  },
  forButton: {
    type: Boolean,
  },
  to: {
    type: Object as PropType<RouteLocationRaw>,
  },
  isOpenInNewTab: {
    type: Boolean,
  },
  color: {
    type: String as PropType<TmBadgeColors | StatusColor>,
    default: 'gray',
  },
  appearance: {
    type: String as PropType<BadgeAppearance>,
    default: 'pastel',
  },
  variant: {
    type: String as PropType<BadgeVariant>,
    default: 'static',
  },
}

export type TmBadgeContentShrink = 'label' | 'additional-text'

export const TmBadgeContentProps = {
  textTransform: {
    type: String as PropType<'lowercase' | 'uppercase' | 'firstLetterUppercase' | 'initial'>,
  },
  shrink: {
    type: String as PropType<TmBadgeContentShrink>,
    default: 'label',
  },
  icon: {
    type: String as PropType<IconName>,
  },
  label: {
    type: [Number, String],
  },
  searchQuery: {
    type: String,
  },
  additionalText: {
    type: [Number, String],
  },
  additionalTextVisible: {
    type: Boolean,
  },
}

export type TmBadgeDeletedEntityEntities =
  | 'contactList'
  | 'contacts'
  | 'segment'
  | 'tag'
  | 'ticketInbox'
  | 'taskBoard'
  | 'taskStage'
  | 'customFieldSchema'
  | 'dealPipeline'
  | 'dealStage'
  | 'webWidget'
  | 'subscribeForm'
  | 'phoneNumber'
  | 'facebook'
  | 'instagram'
  | 'shopifyStore'
  | 'wooCommerceStore'
  | 'automationFlow'
